import React from 'react';
import { Button } from './ui/button';

const CallToAction = () => {
  return (
    <section className="py-20 bg-black text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold mb-4">Opportunities</h2>
          <p className="text-gray-300 max-w-3xl mx-auto text-lg">
            Joker & Quinn loves to hear from you. Simply fill out the form, one of our team experts will get in touch with you
          </p>
        </div>
        
        <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto">
          <div className="bg-white text-black p-8 rounded-lg text-center hover:shadow-xl transition-shadow">
            <h3 className="text-2xl font-bold mb-4">Franchise</h3>
            <p className="text-gray-700 mb-6">
              Partner with us and bring Joker & Quinn's excellence to your city
            </p>
            <Button
              className="bg-black hover:bg-gray-800 text-white px-6 py-3 rounded-full"
              onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
            >
              Learn More
            </Button>
          </div>
          
          <div className="bg-white text-black p-8 rounded-lg text-center hover:shadow-xl transition-shadow">
            <h3 className="text-2xl font-bold mb-4">Career</h3>
            <p className="text-gray-700 mb-6">
              Join our team of expert stylists and grow your career with us
            </p>
            <Button
              className="bg-black hover:bg-gray-800 text-white px-6 py-3 rounded-full"
              onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
            >
              Apply Now
            </Button>
          </div>
          
          <div className="bg-white text-black p-8 rounded-lg text-center hover:shadow-xl transition-shadow">
            <h3 className="text-2xl font-bold mb-4">Business</h3>
            <p className="text-gray-700 mb-6">
              Explore business opportunities and collaborations with us
            </p>
            <Button
              className="bg-black hover:bg-gray-800 text-white px-6 py-3 rounded-full"
              onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
            >
              Contact Us
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CallToAction;
